/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Invited_To_OrgInputs */

const en_invited_to_org = /** @type {(inputs: Invited_To_OrgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have been invited to join organization: ${i?.orgName}.`)
};

const nl_invited_to_org = /** @type {(inputs: Invited_To_OrgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je bent uitgenodigd om lid te worden van organisatie: ${i?.orgName}`)
};

/**
* | output |
* | --- |
* | "You have been invited to join organization: {orgName}." |
*
* @param {Invited_To_OrgInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const invited_to_org = /** @type {((inputs: Invited_To_OrgInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invited_To_OrgInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_invited_to_org(inputs)
	return en_invited_to_org(inputs)
});